import React from 'react';
import parse from 'html-react-parser';

const createMarkup = (htmlText) => {
  return { __html: htmlText };
};

export const parseHtml = (htmlText) => {
  return parse(htmlText);
};

export const decorateString = (text) => {
  if (!text) {
    return <span />;
  }

  let htmlTxt = ` ${text}`;

  htmlTxt = htmlTxt.replace(/([^\\*?])\*(.*?[^\\])\*/g, '$1<b>$2</b>'); // replace * * with <b></b> - bold
  htmlTxt = htmlTxt.replace(/([^\\*?])\+(.*?[^\\])\+/g, '$1<u>$2</u>'); // replace + + with <u></u> - underline
  htmlTxt = htmlTxt.replace(/([^\\*?])_(.*?[^\\])_/g, '$1<i>$2</i>'); // replace _ _ with <i></i> - italic
  htmlTxt = htmlTxt.replace(/([^\\*?])-(.*?[^\\])-/g, '$1<del>$2</del>'); // replace - - with <del></del> - delete/strike-through
  htmlTxt = htmlTxt.replace(/([^\\*?])\^(.*?[^\\])\^/g, '$1<sup>$2</sup>'); // replace ^ ^ with <sup></sup> - superscript
  htmlTxt = htmlTxt.replace(/([^\\*?])~(.*?[^\\])~/g, '$1<sub>$2</sub>'); // replace ~ ~ with <sub></sub> - subscript
  htmlTxt = htmlTxt.replace(/\[#(.*?)\]/g, '<a href=$1>$1</a>'); // replace [#link] with <a href="link">link</a> - anchor
  htmlTxt = htmlTxt.replace(/\[(.*?)\|(.*?)\]/g, '<a href=$2 target="_blank">$1</a>'); // replace [link name | link] with <a href="link">link name</a> - external link with name
  htmlTxt = htmlTxt.replace(/\[mailto:(.*?)\]/g, '<a href=mailto:$1>$1</a>'); // replace [mailto:link] with <a href="mailto:$1">link name</a> - link to email
  htmlTxt = htmlTxt.replace(/\[(.*?)\]/g, '<a href=$1 target="_blank">$1</a>'); // replace [link] with <a href="$1">$1</a> - link without name
  htmlTxt = htmlTxt.replace(/\{color:(.*?)\}(.*?)\{color\}/g, '<span style="color: $1" >$2</span>'); // replace {color:code} txt {color} with <span style={{ color: code}}>txt</spana> - colored text

  htmlTxt = htmlTxt.replace(/\\\*/g, '*');
  htmlTxt = htmlTxt.replace(/\\\+/g, '+');
  htmlTxt = htmlTxt.replace(/\\_/g, '_');
  htmlTxt = htmlTxt.replace(/\\-/g, '-');
  htmlTxt = htmlTxt.replace(/\\\^/g, '^');
  htmlTxt = htmlTxt.replace(/\\~/g, '~');

  return parseHtml(htmlTxt);
};

export const cleanString = (text) => {
  if (!text) {
    return <span />;
  }

  let htmlTxt = ` ${text}`;

  htmlTxt = htmlTxt.replace(/([^\\*?])\*(.*?[^\\])\*/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/([^\\*?])\+(.*?[^\\])\+/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/([^\\*?])_(.*?[^\\])_/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/([^\\*?])-(.*?[^\\])-/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/([^\\*?])\^(.*?[^\\])\^/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/([^\\*?])~(.*?[^\\])~/g, '$1$2'); 
  htmlTxt = htmlTxt.replace(/\[#(.*?)\]/g, '$1'); 
  htmlTxt = htmlTxt.replace(/\[(.*?)\|(.*?)\]/g, '$1'); 
  htmlTxt = htmlTxt.replace(/\[mailto:(.*?)\]/g, '$1'); 
  htmlTxt = htmlTxt.replace(/\[(.*?)\]/g, '$1'); 
  htmlTxt = htmlTxt.replace(/\{color:(.*?)\}(.*?)\{color\}/g, '$2');

  htmlTxt = htmlTxt.replace(/\\\*/g, '*');
  htmlTxt = htmlTxt.replace(/\\\+/g, '+');
  htmlTxt = htmlTxt.replace(/\\_/g, '_');
  htmlTxt = htmlTxt.replace(/\\-/g, '-');
  htmlTxt = htmlTxt.replace(/\\\^/g, '^');
  htmlTxt = htmlTxt.replace(/\\~/g, '~');

  return parseHtml(htmlTxt);
};

export default decorateString;

/*
  OPTION LIST
    *bold*
    -delete-
    +underline+
    _italic_
    ^superscript^
    ~subscript~
    [#link] - anchor
    [https://www.w3schools.com] - external link
    [w3 school | https://www.w3schools.com] - external link with name
    [mailto: csa@test.com] - link to email
    {color:green} text {color} - color text
*/
